export const iconMapper = status => {
	switch (status) {
		case 'ONGOING':
			return 'check-circle'
		case 'SUSPENDED_NO_PAYMENT':
		case 'SUSPENDED':
			return 'warning'
		case 'CANCELED':
		case 'TO_CANCEL':
			return 'block'
		default:
			return 'clock'
	}
  }

  export const iconColorMapper = status => {
	switch (status) {
		case 'ONGOING':
			return 'positive'
		case 'SUSPENDED_NO_PAYMENT':
		case 'SUSPENDED':
			return 'warning'
		case 'CANCELED':
		case 'TO_CANCEL':
			return 'negative'
		default:
			return 'secondary'
	}
  }

  export const policyBackgroundColor = statusId => {
	let backgroundColor = ''

	switch (statusId) {
	case 0:
	case 'ONGOING':
		backgroundColor += '#01a581'
		break

	case 3:
	case 'CANCELED':
	case 4:
	case 'TO_CANCEL':
		backgroundColor += '#d02e44'
		break
	case -1:
	case 'UNKNOWN':
		backgroundColor += '#99ADBD'
		break
	default:
		backgroundColor += '#ec8e00'
		break
	}

	return backgroundColor
}

export const policyStatusIcon = statusId => {
	let status = ''

	switch (statusId) {
	case 0:
	case 'ONGOING':
		status = 'check-circle'
		break

	case 3:
	case 'CANCELED':
	case 4:
	case 'TO_CANCEL':
		status = 'block'
		break

	case 1:
	case 'SUSPENDED_NO_PAYMENT':
	case 2:
	case 'SUSPENDED':
		status = 'warning'
		break
	case -1:
	case 'UNKNOWN':
		status = 'undefined'
		break
	default:
		status = 'clock'
		break
	}

	return status
}

export const isInCanceledStatus = statusId => {
	switch (statusId) {
		case 3:
		case '3':
		case 'CANCELED':
		case 4:
		case '4':
		case 'TO_CANCEL':
			return true

		default:
			return false
	}
}

export const receiptsStatusIcon = statusId => {
	let status = ''

	switch (statusId) {
	case 5:
	case '5':
		status = 'check-circle'
		break
	case 9:
	case '9':
		status = 'block'
		break
	case -1:
	case 'UNKNOWN':
		status = 'undefined'
			break
	default:
		status = 'warning'
		break
	}

	return status
}

export const receiptsIconColorMapper = status => {
	switch (status) {
		case 5:
		case '5':
			return 'positive'
		case 9:
		case '9':
			return 'warning'
		case -1:
		case 'UNKNOWN':
			return 'negative'
		default:
			return 'secondary'
	}
  }

export const receiptsStatusBackgroundColor = statusId => {
	let backgroundColor = ''

	switch (statusId) {
	case 5:
	case '5':
		backgroundColor += '#01a581'
		break

	case 9:
	case '9':
		backgroundColor += '#d02e44'
		break

	case -1:
	case 'UNKNOWN':
		backgroundColor += '#99ADBD'
		break

	default:
		backgroundColor += '#ec8e00'
		break
	}

	return backgroundColor
}
